export const accountingLoadError = 'Unable to load Accounting';
